import type { Meal } from "@heliopolis/schema/meal.js";
import type { CSSProperties, JSX } from "react";
import MealCard from "./MealCard.tsx";

type MealListingProps = {
  meals?: ReadonlyArray<Meal>;
};

export default function MealListing(props: MealListingProps): JSX.Element {
  const { meals } = props;

  return (
    <div style={Style.Grid}>
      {meals?.map((meal) => (
        <MealCard key={meal.name} meal={meal} />
      ))}
    </div>
  );
}

const Style = {
  Grid: {
    display: "grid",
    gap: "16px",
    gridAutoFlow: "row",
    width: "100%",
    gridTemplateColumns: "repeat(auto-fit, minmax(600px, 1fr))",
  },
} as const satisfies Record<string, CSSProperties>;
